export const PROJECT_TAGS = {
  WEB: "Web",
  SAAS: "SaaS",
  MOBILE: "Mobile",
  GROWTH: "Growth",
  GAME: "Jeu",
  TOOL: "Outil",
  AI: "IA",
  IN_PROGRESS: "En cours",
};

const coreProjects = [
  {
    slug: "airbus-helicopters-ce",
    title: "Airbus Helicopters (CE)",
    subtitle:
      "Application iOS/Android (Flutter) pour le CE - réductions & avantages employés",
    tags: [PROJECT_TAGS.MOBILE],
    featured: true,

    meta: {
      year: 2024,
      duration: "≈ 3 semaines",
      deliveryMode: "Dreamer Agency (2 personnes)",
      confidentiality:
        "Public (présentation). Accès app protégé par mot de passe interne CE.",
      availability: "Disponible sur App Store & Play Store",
    },

    infra: [
      "Application Flutter + Firebase (backend managé)",
      "Déploiement via App Store & Play Store",
      "Accès protégé par mot de passe (usage interne CE Airbus Helicopters)",
    ],

    role: [
      "Maquettes UI/UX",
      "Développement Flutter (iOS/Android)",
      "Structuration contenu (catégories / sous-catégories)",
      "Déploiement & livraison",
    ],

    highlights: [
      "Home premium avec 7 vidéos en background (lecture simultanée) sans latence perçue",
      "Navigation “volatile” : barre qui disparaît au scroll pour maximiser la lisibilité",
      "Parcours clair : catégories / sous-catégories + recherche rapide",
      "Accès sécurisé : app visible publiquement mais protégée par mot de passe (employés uniquement)",
    ],

    stack: ["Flutter", "iOS / Android", "Déploiement stores"],
    links: {
      website: null,
      appStore: "https://apps.apple.com/us/app/guide-plan-de-vol/id6499146800",
      playStore: "https://play.google.com/store/apps/details?id=com.airbus_helicopters",
    },

    brand: {
      logo: "TODO_LOGO",
    },
    gallery: [
        { src: "/media/achievements/airbus_1.jpg", format: "mobile" },
        { src: "/media/achievements/airbus_2.jpg", format: "mobile" },
        { src: "/media/achievements/airbus_3.jpg", format: "mobile" },
        { src: "/media/achievements/airbus_4.jpg", format: "mobile" },
    ],
  },

  {
    slug: "echo-review",
    title: "Echo Review",
    subtitle:
      "SaaS B2B - gestion d’avis Google + “pare-feu” pour protéger la réputation",
    tags: [PROJECT_TAGS.SAAS, PROJECT_TAGS.GROWTH],
    featured: true,

    meta: {
      year: 2024,
      duration: "≈ 1 mois",
      deliveryMode: "Développement complet Dreamer Agency",
      confidentiality: "Public",
      availability: "En ligne",
    },

    infra: [
      "Frontend + backend hébergés sur serveur dédié Dreamer Agency",
      "Base de données hébergée sur Dreamer Agency",
      "Paiements Stripe (abonnements)",
    ],

    role: [
      "Produit & UX (parcours, dashboard)",
      "Front React",
      "Backend Node.js",
      "Base de données",
      "Paiements & abonnements Stripe",
    ],

    highlights: [
      "“Pare-feu” d’avis : capte les retours négatifs et oriente les avis 4–5★ vers Google",
      "Connexion Google / Facebook (onboarding rapide côté restaurateurs)",
      "Dashboard analytics (indicateurs, suivi, stats)",
      "Abonnements Stripe (3 plans)",
      "Adoption : dizaines d’utilisateurs - amélioration progressive de la note Google observée chez certains clients",
    ],

    stack: ["React", "Node.js", "Base de données", "Stripe"],
    links: {
      website: "https://echoreview.fr",
      appStore: null,
      playStore: null,
    },

    brand: {
      logo: "TODO_LOGO",
    },
    gallery: [
        { src: "/media/achievements/echoreview_1.png", format: "desktop" },
        { src: "/media/achievements/echoreview_2.png", format: "desktop" },
        { src: "/media/achievements/echoreview_3.png", format: "desktop" },
        { src: "/media/achievements/echoreview_4.png", format: "desktop" },
        { src: "/media/achievements/echoreview_5.png", format: "desktop" },
        { src: "/media/achievements/echoreview_6.png", format: "desktop" },
    ],
  },

  {
    slug: "trace",
    title: "Trace",
    subtitle:
      "App exploration : fog-of-war, tuiles à débloquer, badges, lieux, social & chat",
    tags: [PROJECT_TAGS.MOBILE],
    featured: true,

    meta: {
      year: 2026,
      duration: "≈ 1 mois",
      deliveryMode: "Développement complet (design + front + back)",
      confidentiality: "Public",
      availability: "Publication imminente (validation stores)",
    },

    infra: [
      "Backend Node.js hébergé sur serveur dédié Dreamer Agency",
      "Services map : Mapbox",
      "Indexation tuiles : H3",
      "Publication stores (validation en cours)",
    ],

    role: [
      "Design & UI",
      "App Flutter",
      "Backend Node.js",
      "Système tuiles / progression",
      "Social (amis, feed, chat, privacy)",
    ],

    highlights: [
      "Carte en fog-of-war : déblocage progressif des zones au fil de la marche",
      "Système de tuiles adaptatives : petites tuiles en ville, plus grandes en campagne/axes rapides",
      "Badges & succès : conditions de déblocage avancées (logique complexe)",
      "Social V1 : feed, recherche, amis, messagerie, profil public/privé",
      "Stores : sortie prévue début mars 2026 (selon validation)",
    ],

    stack: ["Flutter", "Node.js", "Mapbox", "H3 (tiling)"],
    links: {
      website: null,
      appStore: "TODO_APPSTORE_URL",
      playStore: "TODO_PLAYSTORE_URL",
    },

    brand: {
      logo: "TODO_LOGO",
    },
    gallery: [
        { src: "/media/achievements/trace_1.jpg", format: "mobile" },
        { src: "/media/achievements/trace_2.jpg", format: "mobile" },
        { src: "/media/achievements/trace_3.jpg", format: "mobile" },
        { src: "/media/achievements/trace_4.jpg", format: "mobile" },
        { src: "/media/achievements/trace_5.jpg", format: "mobile" },
        { src: "/media/achievements/trace_6.jpg", format: "mobile" },
    ],
  },
  {
    slug: "ila",
    title: "ILA",
    subtitle:
        "Site premium (Vite/Node) + blog headless (WordPress) avec hub Guides / Articles",
    tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.GROWTH],
    featured: true,

    meta: {
        year: 2026,
        duration: "≈ 3–4 jours",
        deliveryMode: "Dreamer Agency (2 personnes)",
        confidentiality: "Public",
        availability: "En ligne",
    },

    infra: [
        "Front + backend hébergés sur serveur dédié Dreamer Agency",
        "Contenu blog via WordPress (hébergé côté client)",
    ],

    role: [
        "Design UI/UX (premium, épuré)",
        "Développement front (Vite)",
        "Backend Node.js",
        "Architecture blog : hub Guides / Articles",
        "Intégration headless WordPress (récupération des contenus)",
        "Déploiement",
    ],

    highlights: [
        "Design premium : simple, lisible, très ‘clean’",
        "Blog structuré : hub + séparation Guides / Articles pour une navigation claire",
        "Base technique rapide & maintenable (Vite + Node)",
        "Contenu géré côté client via WordPress, synchronisé côté site",
    ],

    stack: ["Vite", "Node.js", "WordPress (headless)", "SEO (structure)"],

    links: {
        website: "https://corporateimmigration.eu/",
        appStore: null,
        playStore: null,
    },

    brand: {
        logo: "TODO_ILA_LOGO",
    },
    gallery: [
        { src: "/media/achievements/ila_1.png", format: "desktop" },
        { src: "/media/achievements/ila_2.png", format: "desktop" },
        { src: "/media/achievements/ila_3.png", format: "desktop" },
        { src: "/media/achievements/ila_4.png", format: "desktop" },
    ],
    },
    {
        slug: "sco",
        title: "SCO",
        subtitle:
            "Refonte complète (Vite) + SEO local (40+ pages) + calculateur de prix & itinéraire",
        tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.GROWTH],
        featured: true,

        meta: {
            year: 2025,
            duration: "≈ 1 semaine",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "En ligne",
        },

        infra: ["Site hébergé sur serveur dédié Dreamer Agency"],

        role: [
            "Refonte design (0) + migration techno (ancien JS → Vite)",
            "Reprise/optimisation d’une grande partie du contenu existant",
            "Mise en place SEO local (structure, pages destinations)",
            "Intégration calculateur : itinéraire + estimation prix",
            "Déploiement",
        ],

        highlights: [
            "Refonte complète : UI plus premium + codebase moderne (Vite)",
            "SEO local à grande échelle : ~40 pages de destinations",
            "Amélioration du positionnement sur des pages clés (Ouest / Nord-Ouest)",
            "Impact business : davantage d’appels et de prises de RDV transport",
            "Calculateur de prix/itinéraire directement sur la page d’accueil",
        ],

        stack: ["Vite", "SEO local", "Routing", "Calculateur (trajet/prix)"],

        links: {
            website: "https://www.services-chauffeurs-occasionnels.fr/",
            appStore: null,
            playStore: null,
        },

        brand: {
            logo: "TODO_SCO_LOGO",
        },
        gallery: [
            { src: "/media/achievements/sco_1.png", format: "desktop" },
            { src: "/media/achievements/sco_2.png", format: "desktop" },
            { src: "/media/achievements/sco_3.png", format: "desktop" },
            { src: "/media/achievements/sco_4.png", format: "desktop" },
        ],
    },
    {
        slug: "domaine-du-leou",
        title: "Domaine du Léou",
        subtitle:
            "Site + réservation + paiement (Stripe custom) + sync calendrier Airbnb + panneau admin",
        tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.SAAS],
        featured: true,

        meta: {
            year: 2024,
            duration: "≈ 1 mois",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "En ligne",
        },

        infra: [
            "Front + backend + calendrier maître hébergés sur serveur dédié Dreamer Agency",
            "Synchronisation Airbnb (Airbnb se cale sur le calendrier serveur)",
        ],

        role: [
            "Design + développement complet (front & back)",
            "Système de réservation (3 gîtes) + calendrier",
            "Synchronisation Airbnb (calendriers)",
            "Paiement Stripe intégré (composant custom, pas la page Stripe standard)",
            "Acompte + logique d’annulation",
            "Factures automatiques envoyées aux 2 parties",
            "Panneau admin : gestion réservations (annulation, relances, etc.)",
            "Déploiement",
        ],

        highlights: [
            "Réservation complète : 3 gîtes, calendrier fiable + sync Airbnb",
            "Paiement Stripe custom + acompte (et annulation encadrée)",
            "Automatisation : factures + emails envoyés aux deux parties",
            "Panneau admin : gestion simple et rapide des réservations (gérants)",
            "Adoption : augmentation des réservations + retours positifs sur l’expérience",
        ],

        stack: ["React", "Node.js", "Stripe (custom)", "Calendrier & sync Airbnb", "Admin panel"],

        links: {
            website: "https://domaine-du-leou.fr",
            appStore: null,
            playStore: null,
        },

        brand: {
            logo: "TODO_LEOU_LOGO",
        },
        gallery: ["TODO_LEOU_1", "TODO_LEOU_2", "TODO_LEOU_3", "TODO_LEOU_4", "TODO_LEOU_5"],
    },
    /* Legacy Hyroos draft disabled; active entry is in additionalProjects.
    {
        legacySlug: "hyroos",
        title: "Hyroos",
        subtitle:
            "App fitness IA : tracking caméra frontale + scoring MoveNet + classements & badges",
        tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.SAAS],
        featured: true,

        meta: {
            year: 2025,
            duration: "≈ 3 mois",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "Disponible sur App Store & Play Store (MVP)",
        },

        infra: [
            "Backend Node.js + services Python (MoveNet / scoring) hébergés sur serveur dédié Dreamer Agency",
            "Supabase (données & classement)",
            "App publiée sur App Store & Play Store",
            "Vidéos de référence fournies par le client (contenu), système de tracking/scoring par Dreamer Agency",
        ],

        role: [
            "Design UI/UX",
            "App mobile React Native (caméra + tracking)",
            "Backend Node.js",
            "Services Python : MoveNet + scoring",
            "Classements (semaine / mois / global + par exercice)",
            "Badges & progression",
            "Déploiement / publication stores",
        ],

        highlights: [
            "Tracking via caméra frontale + comparaison à un référentiel (vidéo)",
            "Scoring automatique côté serveur (MoveNet) pour mesurer la performance",
            "Classements multi-niveaux : semaine, mois, global, et par exercice",
            "Système de badges pour renforcer la progression (gamification)",
            "MVP publié : itérations produit en cours",
        ],

        stack: [
            "React Native",
            "Node.js",
            "Python (MoveNet)",
            "Supabase",
            "IA / Computer Vision",
            "iOS / Android",
        ],

        links: {
            website: null,
            appStore: "TODO_HYROOS_APPSTORE_URL",
            playStore: "TODO_HYROOS_PLAYSTORE_URL",
        },

        brand: {
            logo: "TODO_HYROOS_LOGO",
        },
        gallery: ["TODO_HYROOS_1", "TODO_HYROOS_2", "TODO_HYROOS_3", "TODO_HYROOS_4", "TODO_HYROOS_5"],
    },*/
    {
        slug: "duo-date",
        title: "Duo Date",
        subtitle:
            "App couple : 250+ idées de dates + progression + photos partagées + compte partenaire",
        tags: [PROJECT_TAGS.MOBILE],
        featured: true,

        meta: {
            year: 2024,
            duration: "≈ 2 mois",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "Disponible sur App Store & Play Store + site vitrine",
        },

        infra: [
            "Backend principal Firebase (auth, data, sync)",
            "Complément Node.js léger hébergé sur serveur dédié Dreamer Agency",
            "Site vitrine one-page hébergé sur Dreamer Agency",
            "Monétisation via achats intégrés (Apple / Google)",
            "App publiée sur App Store & Play Store",
        ],

        role: [
            "Design UI/UX",
            "Développement Flutter (iOS/Android)",
            "Architecture Firebase (sync couple, data, médias)",
            "Site vitrine one-page (redirection stores)",
            "Mise en place des abonnements (IAP)",
            "Déploiement / publication stores",
        ],

        highlights: [
            "Catalogue 250+ dates (idées + infos) + suivi de progression",
            "Association dates ↔ photos, et historique partagé",
            "Lien partenaire : synchronisation des dates, des photos et des moments",
            "Monétisation via abonnement (Apple / Google)",
            "Adoption : quelques centaines d’utilisateurs",
        ],

        stack: [
            "Flutter",
            "Firebase",
            "Node.js (complément)",
            "iOS / Android",
            "IAP (Apple / Google)",
        ],

        links: {
            website: "https://duo-date.fr/",
            appStore: "https://apps.apple.com/us/app/duo-date/id6499107057",
            playStore: "https://play.google.com/store/apps/details?id=com.duo_date",
        },

        brand: {
            logo: "TODO_DUODATE_LOGO",
        },
        gallery: [
            { src: "/media/achievements/duodate_1.jpg", format: "mobile" },
            { src: "/media/achievements/duodate_2.jpg", format: "mobile" },
            { src: "/media/achievements/duodate_3.jpg", format: "mobile" },
            { src: "/media/achievements/duodate_4.jpg", format: "mobile" },
        ],
    },
    {
        slug: "epopee-vf",
        title: "Épopée VF",
        subtitle:
            "Fantasy cycling : site + app mobile + backend - équipes, calendrier, points & classements",
        tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.MOBILE, PROJECT_TAGS.GAME],
        featured: true,

        meta: {
            year: 2025,
            duration: "Site ~6 semaines (2023/2024) • évolutions ~1 mois (2024) • app ~2 mois (2025)",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "En ligne + App Store & Play Store",
        },

        infra: [
            "Site web (front) + serveur backend hébergés sur serveur dédié Dreamer Agency",
            "Backend unique partagé site + app (logique commune)",
            "App publiée sur App Store & Play Store",
        ],

        role: [
            "Design UI/UX",
            "Site web React",
            "App mobile Flutter",
            "Backend Node.js (site + app)",
            "Automatisation scoring (résultats → points → classements)",
            "Déploiement / publication stores",
        ],

        highlights: [
            "Création d’équipe + calendrier personnel (modifications possibles au début de chaque mois)",
            "Calcul automatique des points selon les résultats réels et mise à jour des classements",
            "Classements multiples : joueurs, cyclistes, amis, leagues",
            "Très bons retours : centaines de joueurs chaque année (proche du millier avec l’app)",
            "Produit complet : web + mobile + backend partagé",
        ],

        stack: ["React", "Flutter", "Node.js", "Base de données", "iOS / Android"],

        links: {
            website: "https://vf-fantasy-cyclisme.velofute.com/",
            appStore: "https://apps.apple.com/us/app/epop%C3%A9e-vf/id6756826740",
            playStore: "https://play.google.com/store/apps/details?id=com.velofute_app",
        },

        brand: {
            logo: "TODO_VELOFUTE_LOGO",
        },
        gallery: [
            { src: "/media/achievements/epopee_1.png", format: "desktop" },
            { src: "/media/achievements/epopee_2.png", format: "desktop" },
            { src: "/media/achievements/epopee_3.jpg", format: "mobile" },
            { src: "/media/achievements/epopee_4.jpg", format: "mobile" },
            { src: "/media/achievements/epopee_5.jpg", format: "mobile" },
            { src: "/media/achievements/epopee_6.jpg", format: "mobile" },
        ],
    },
    /* Legacy PsychIA draft disabled; active entry is in additionalProjects.
    {
        legacySlug: "psychia",
        title: "Psychia",
        subtitle:
            "App IA d’accompagnement psycho : chat + vocal + confidentialité + forum d’entraide",
        tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.SAAS],
        featured: true,

        meta: {
            year: 2025,
            duration: "≈ 2 mois",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "Disponible sur App Store & Play Store + site vitrine",
        },

        infra: [
            "Backend + RAG + orchestration Docker hébergés sur OVH",
            "Serveur GPU dédié (RTX 5000) sur OVH pour exécuter le modèle IA",
            "Site vitrine one-page",
            "App publiée sur App Store & Play Store",
        ],

        role: [
            "Développement app mobile (front)",
            "Backend (PHP) + APIs",
            "Pipeline RAG (retrieval + génération)",
            "Intégration IA : modèle personnalisé 13B (serveur GPU)",
            "Dockerisation & déploiement",
            "Site vitrine one-page",
        ],

        highlights: [
            "Onboarding sécurisé : email ou téléphone + vérification SMS",
            "Chatbot IA personnel basé sur un modèle 13B personnalisé",
            "Confidentialité : conversations stockées localement sur le téléphone",
            "Conversation vocale (mode voice)",
            "Forum d’entraide (communauté)",
            "Lancement récent : quelques dizaines d’utilisateurs, croissance portée par marketing TikTok / réseaux sociaux",
        ],

        stack: [
            "React Native",
            "Backend PHP",
            "RAG",
            "Docker",
            "GPU (RTX 5000)",
            "IA (modèle 13B)",
            "iOS / Android",
        ],

        links: {
            website: "https://psychia.fr/",
            appStore: "https://apps.apple.com/fr/app/psychia/id6744969909",
            playStore: "https://play.google.com/store/apps/details?id=fr.psychia.androidapp",
        },

        brand: {
            logo: "TODO_PSYCHIA_LOGO",
        },
        gallery: [
            { src: "/media/achievements/psychia_1.png", format: "mobile" },
            { src: "/media/achievements/psychia_2.png", format: "mobile" },
            { src: "/media/achievements/psychia_3.png", format: "mobile" },
            { src: "/media/achievements/psychia_4.png", format: "mobile" },
        ],
    },*/
    {
        slug: "match-assess",
        title: "Match Assess",
        subtitle:
            "App sports (foot & tennis) : matchs, tournois, résultats, classement + social & messagerie",
        tags: [PROJECT_TAGS.MOBILE],
        featured: true,

        meta: {
            year: 2025,
            duration: "≈ 2 mois",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "Disponible sur App Store & Play Store",
        },

        infra: [
            "Backend PHP hébergé sur OVH",
            "App publiée sur App Store & Play Store",
        ],

        role: [
            "Design UI/UX",
            "App mobile React Native",
            "Backend PHP (API + logique tournois)",
            "Système social : amis, recherche, messagerie",
            "Déploiement / publication stores",
        ],

        highlights: [
            "Création de matchs (tennis/foot) + recherche de matchs et tournois",
            "Gestion de tournois : résultats, classement, playoffs automatisés",
            "Enregistrement équipes & joueurs, profils personnalisés (photo + caractéristiques)",
            "Messagerie + liste d’amis",
            "Adoption : centaines d’utilisateurs (croissance progressive, surtout région parisienne)",
        ],

        stack: ["React Native", "Backend PHP", "iOS / Android"],

        links: {
            website: "https://www.match-assess.fr/",
            appStore: "https://apps.apple.com/fr/app/match-assess/id6444630977",
            playStore: "https://play.google.com/store/apps/details?id=com.match.assess",
        },

        brand: {
            logo: "TODO_MATCHASSESS_LOGO",
        },
        gallery: [
            { src: "/media/achievements/match_assess_1.png", format: "mobile" },
            { src: "/media/achievements/match_assess_2.png", format: "mobile" },
            { src: "/media/achievements/match_assess_3.png", format: "mobile" },
            { src: "/media/achievements/match_assess_4.png", format: "mobile" },
            { src: "/media/achievements/match_assess_5.png", format: "mobile" },
            { src: "/media/achievements/match_assess_6.png", format: "mobile" },
        ],
    },
    {
        slug: "pixel-battle",
        title: "Pixel Battle",
        subtitle:
            "Jeu web temps réel type Pixel War : pixels, alliances, items, boutique & chat",
        tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.GAME],
        featured: true,

        meta: {
            year: 2026,
            duration: "≈ 3–4 semaines (fin 2025 → début 2026)",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "En ligne",
        },

        infra: [
            "Frontend + backend hébergés sur serveur dédié Dreamer Agency",
            "Temps réel via Socket.IO",
            "Paiements Stripe (boutique d’items)",
        ],

        role: [
            "Game design (mécaniques + économie items)",
            "Frontend (Vite)",
            "Backend Node.js + Socket.IO",
            "Chat & alliances",
            "Système items (bombes, mines, ultra-speed…) + boutique Stripe",
            "Déploiement",
        ],

        highlights: [
            "Canvas collaboratif : poser des pixels en temps réel (style Pixel War)",
            "Synchronisation live multi-utilisateurs via Socket.IO",
            "Alliances + chat intégré directement dans le jeu",
            "Items utilisables sur la zone : bombes, mines, boost vitesse, etc.",
            "Masques / calques possibles pour suivre un modèle de dessin",
            "Boutique Stripe pour acheter des items",
            "Lancement proche : attente forte (pré-lancement)",
        ],

        stack: ["Vite", "Node.js", "Socket.IO", "Stripe", "Temps réel"],

        links: {
            website: "https://pixelbattle.eu/",
            appStore: null,
            playStore: null,
        },

        brand: {
            logo: "TODO_PIXELBATTLE_LOGO",
        },
        gallery: [
            { src: "/media/achievements/pixel_battle_1.png", format: "desktop" },
            { src: "/media/achievements/pixel_battle_2.png", format: "desktop" },
            { src: "/media/achievements/pixel_battle_3.png", format: "desktop" },
            { src: "/media/achievements/pixel_battle_4.png", format: "desktop" },
        ],
    },
    {
        slug: "lmp",
        title: "LMP",
        subtitle:
            "Site vitrine premium + blog avancé (hub, articles, guides) via WordPress headless",
        tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.GROWTH],
        featured: true,

        meta: {
            year: 2025,
            duration: "≈ 3–4 jours",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "En ligne",
        },

        infra: [
            "Front + backend hébergés sur serveur dédié Dreamer Agency",
            "Contenu blog récupéré via WordPress (hébergé côté client)",
        ],

        role: [
            "Design premium (plus simple que ILA)",
            "Développement front (Vite)",
            "Backend Node.js",
            "Blog structuré : hub + guides / articles",
            "Intégration WordPress headless",
            "Déploiement",
        ],

        highlights: [
            "Design premium, épuré, orienté clarté",
            "Blog avancé : hub + organisation Guides / Articles",
            "Base technique rapide et maintenable (Vite + Node)",
            "Contenu piloté via WordPress côté client",
        ],

        stack: ["Vite", "Node.js", "WordPress (headless)", "SEO (structure)"],

        links: {
            website: "https://labourmobilitypartners.com/",
            appStore: null,
            playStore: null,
        },

        brand: {
            logo: "TODO_LMP_LOGO",
        },
        gallery: [
            { src: "/media/achievements/lmp_1.png", format: "desktop" },
            { src: "/media/achievements/lmp_2.png", format: "desktop" },
            { src: "/media/achievements/lmp_3.png", format: "desktop" },
            { src: "/media/achievements/lmp_4.png", format: "desktop" },
        ],
    },
    {
        slug: "sdrh",
        title: "SDRH Consulting",
        subtitle:
            "Site Wix + SEO : reconversion, bilan de compétences, orientation + prise de RDV",
        tags: [PROJECT_TAGS.WEB, PROJECT_TAGS.GROWTH],
        featured: false,

        meta: {
            year: 2025,
            duration: "≈ 1 mois (SEO principalement)",
            deliveryMode: "Dreamer Agency",
            confidentiality: "Public",
            availability: "En ligne",
        },

        infra: [
            "Site réalisé et hébergé sur Wix",
            "SEO + fiche Google Business Profile + prise de RDV",
        ],

        role: [
            "Accompagnement structure du site Wix",
            "Optimisations SEO (structure, contenus, pages)",
            "Ajustements UI/UX (retouches + cohérence)",
            "Mise en place / amélioration prise de RDV",
            "Optimisation fiche Google (local)",
        ],

        highlights: [
            "Site ~20 pages : services, collaborations, événements, contenus",
            "Thématiques : reconversion pro, bilan de compétences, orientation scolaire",
            "SEO poussé (Wix + fiche Google) avec progression au fil des mois",
            "Impact : hausse nette des visites et des prises de RDV (multipliées sur plusieurs mois)",
        ],

        stack: ["Wix", "SEO", "Google Business Profile", "Prise de RDV"],

        links: {
            website: "https://www.sdrhconsulting.fr/",
            appStore: null,
            playStore: null,
        },

        brand: {
            logo: "TODO_SDRH_LOGO",
        },
        gallery: [
            { src: "/media/achievements/sdrh_1.png", format: "desktop" },
            { src: "/media/achievements/sdrh_2.png", format: "desktop" },
            { src: "/media/achievements/sdrh_3.png", format: "desktop" },
            { src: "/media/achievements/sdrh_4.png", format: "desktop" },
        ],
    }
];

const projectStrategy = {
  "airbus-helicopters-ce": {
    shortTitle: "Airbus CE",
    type: "Application mobile interne",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 40,
    featured: false,
    summary:
      "Application mobile Flutter pour rendre accessibles des avantages internes aux employes Airbus Helicopters.",
    businessSummary:
      "Projet utile pour la credibilite client et la livraison mobile, sans le positionner comme projet produit complexe.",
    technicalSummary:
      "Application Flutter iOS/Android avec Firebase, publication stores et acces protege par mot de passe.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  "echo-review": {
    shortTitle: "EchoReview",
    type: "SaaS B2B",
    strategicLevel: "featured",
    status: "production",
    section: "featured",
    priority: 40,
    featuredRank: 4,
    summary:
      "SaaS B2B pour piloter la collecte d'avis Google, les liens de retour client et un dashboard de suivi.",
    businessSummary:
      "Bon exemple de produit B2B complet : onboarding, dashboard, abonnement et logique metier claire.",
    technicalSummary:
      "React, Node.js, base de donnees, Stripe, OAuth Google et deploiement serveur.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  trace: {
    shortTitle: "Mystery Hike / Trace",
    type: "Application mobile geolocalisee",
    strategicLevel: "featured",
    status: "mvp",
    section: "featured",
    priority: 50,
    featuredRank: 5,
    summary:
      "Application mobile d'exploration avec carte, tuiles a debloquer, progression, badges et couche sociale.",
    businessSummary:
      "Projet fort pour montrer une logique produit mobile, geolocalisation, gamification et experience sociale.",
    technicalSummary:
      "Flutter, Node.js, Mapbox, indexation H3, logique de tuiles et fonctionnalites sociales.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  ila: {
    shortTitle: "ILA",
    type: "Site vitrine premium",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 30,
    featured: false,
    summary:
      "Site premium Vite/Node avec contenu WordPress headless et structure blog Guides / Articles.",
    businessSummary:
      "Projet client utile pour montrer la qualite d'integration, la clarte UX et le SEO de contenu.",
    technicalSummary:
      "Vite, Node.js, WordPress headless, architecture blog et deploiement.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  sco: {
    shortTitle: "SCO",
    type: "Site vitrine SEO local",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 10,
    featured: false,
    summary:
      "Refonte de site chauffeur prive avec SEO local, pages de destination et calculateur de prix/itineraire.",
    businessSummary:
      "Projet client concret, oriente acquisition locale et conversion.",
    technicalSummary:
      "Vite, routing, structure SEO locale et calculateur integre.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  "domaine-du-leou": {
    shortTitle: "Domaine du Leou",
    type: "Plateforme de reservation",
    strategicLevel: "strong",
    status: "production",
    section: "apps",
    priority: 120,
    featured: false,
    summary:
      "Site avec reservation, paiement Stripe custom, synchronisation calendrier et panneau admin.",
    businessSummary:
      "Projet hybride client/produit interessant pour montrer logique metier, paiement et automatisations.",
    technicalSummary:
      "React, Node.js, Stripe, calendrier, sync Airbnb, emails/factures et admin panel.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  "duo-date": {
    shortTitle: "Duo Date",
    type: "Application mobile consumer",
    strategicLevel: "strong",
    status: "production",
    section: "apps",
    priority: 70,
    featured: false,
    summary:
      "Application mobile d'idees de sorties en couple, avec progression, media partages et compte partenaire.",
    businessSummary:
      "Bon projet mobile public avec synchronisation de donnees, experience couple et monetisation in-app.",
    technicalSummary:
      "Flutter, Firebase, complement Node.js, achats integres et publication stores.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  "epopee-vf": {
    shortTitle: "Velofute",
    type: "Fantasy game cyclisme",
    strategicLevel: "featured",
    status: "production",
    section: "featured",
    priority: 60,
    featuredRank: 6,
    summary:
      "Produit fantasy cycling avec web app, application mobile, backend, equipes, calendrier, points et classements.",
    businessSummary:
      "Projet produit complet, utile pour montrer une logique de jeu, des classements et une base web/mobile partagee.",
    technicalSummary:
      "React, Flutter, Node.js, base de donnees, scoring automatise et publication mobile.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  "match-assess": {
    shortTitle: "Match Assess",
    type: "Application mobile sport",
    strategicLevel: "strong",
    status: "production",
    section: "apps",
    priority: 90,
    featured: false,
    summary:
      "Application mobile pour organiser des matchs, tournois, classements et interactions sociales sportives.",
    businessSummary:
      "Projet mobile utile pour montrer creation d'evenements, profils, messagerie et logique de tournoi.",
    technicalSummary:
      "React Native, backend PHP, logique tournoi, profils, amis et messagerie.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  "pixel-battle": {
    shortTitle: "Pixelwar",
    type: "Jeu web temps reel",
    strategicLevel: "strong",
    status: "mvp",
    section: "apps",
    priority: 100,
    featured: false,
    summary:
      "Web app type Pixel War avec canvas collaboratif, items, alliances, chat et interactions temps reel.",
    businessSummary:
      "Projet utile pour montrer le temps reel, une logique de jeu et une economie d'items.",
    technicalSummary:
      "Vite, Node.js, Socket.IO, Stripe, canvas collaboratif et mecanismes d'items.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  lmp: {
    shortTitle: "LMP",
    type: "Site vitrine premium",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 35,
    featured: false,
    summary:
      "Site vitrine premium avec blog avance via WordPress headless.",
    businessSummary:
      "Projet client orientee clarte, presence professionnelle et contenu long terme.",
    technicalSummary:
      "Vite, Node.js, WordPress headless, structure Guides / Articles et SEO.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
  sdrh: {
    shortTitle: "SDRH Consulting",
    type: "Site client SEO",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 60,
    featured: false,
    summary:
      "Accompagnement site Wix, SEO, structure de contenu, fiche Google et parcours de prise de rendez-vous.",
    businessSummary:
      "Projet utile pour montrer l'accompagnement freelance, le SEO et l'optimisation d'un site existant.",
    technicalSummary:
      "Wix, SEO, Google Business Profile, structure de pages et prise de rendez-vous.",
    hasDetailedCaseStudy: true,
    isPublic: true,
  },
};

const additionalProjects = [
  {
    slug: "autogestia",
    title: "Autogestia",
    shortTitle: "Autogestia",
    subtitle:
      "SaaS de gestion pour artisans et entreprises : devis, facturation, automatisations et IA vocale",
    type: "SaaS metier",
    strategicLevel: "featured",
    status: "in-progress",
    section: "featured",
    priority: 10,
    featured: true,
    featuredRank: 1,
    summary:
      "Application de gestion metier orientee artisans/entreprises, avec devis, facturation, automatisations et assistance IA.",
    businessSummary:
      "Projet fort pour montrer la capacite a structurer un produit SaaS metier complet.",
    technicalSummary:
      "Frontend, backend, base de donnees, API, logique metier, automatisations et briques IA vocales.",
    tags: [PROJECT_TAGS.SAAS, PROJECT_TAGS.TOOL, PROJECT_TAGS.AI, PROJECT_TAGS.IN_PROGRESS],
    stack: ["React", "Node.js", "TypeScript", "Base de donnees", "IA vocale"],
    meta: {
      year: 2026,
      duration: "En cours",
      deliveryMode: "Produit Dreamer Agency",
      confidentiality: "Projet en developpement",
      availability: "En developpement",
    },
    infra: [
      "Architecture full-stack",
      "Logique devis / facturation",
      "Automatisations metier",
      "Briques IA vocales selon perimetre",
    ],
    role: [
      "Architecture produit",
      "Developpement full-stack",
      "Modelisation des donnees",
      "Automatisations et integrations",
    ],
    highlights: [
      "Gestion metier centralisee",
      "Devis et facturation",
      "Automatisations pour reduire les actions repetitives",
      "Approche SaaS evolutive",
    ],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "relyo",
    title: "Relyo",
    shortTitle: "Relyo",
    subtitle:
      "Plateforme metier de profils professionnels, missions, reseau, messagerie, demandes et roles",
    type: "Application metier",
    strategicLevel: "featured",
    status: "in-progress",
    section: "featured",
    priority: 20,
    featured: true,
    featuredRank: 2,
    summary:
      "Plateforme metier complete autour de profils, missions, interactions reseau, messagerie et gestion de roles.",
    businessSummary:
      "Projet fort pour illustrer une application B2B avec workflow, permissions et logique metier.",
    technicalSummary:
      "Frontend React/Vite, backend Node/Express, Prisma et modelisation relationnelle.",
    tags: [PROJECT_TAGS.SAAS, PROJECT_TAGS.TOOL, PROJECT_TAGS.IN_PROGRESS],
    stack: ["React", "Vite", "Node.js", "Express", "Prisma"],
    meta: {
      year: 2026,
      duration: "En cours",
      deliveryMode: "Developpement full-stack",
      confidentiality: "Projet en developpement",
      availability: "En developpement",
    },
    infra: [
      "Frontend React/Vite",
      "Backend Node/Express",
      "Schema de donnees Prisma",
      "Gestion de roles et workflows",
    ],
    role: [
      "Architecture full-stack",
      "Developpement frontend",
      "Developpement backend",
      "Modelisation donnees et permissions",
    ],
    highlights: [
      "Profils professionnels",
      "Demandes et missions",
      "Messagerie et interactions reseau",
      "Roles et logique metier",
    ],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "hyroos",
    title: "Hyroos",
    shortTitle: "Hyroos",
    subtitle:
      "Application mobile d'exercices avec camera, scoring MoveNet et backend de traitement",
    type: "Application mobile IA",
    strategicLevel: "featured",
    status: "mvp",
    section: "featured",
    priority: 30,
    featured: true,
    featuredRank: 3,
    summary:
      "Application mobile d'exercices avec analyse camera, scoring, progression et backend de traitement.",
    businessSummary:
      "Projet fort pour montrer mobile, IA/vision, scoring et architecture backend.",
    technicalSummary:
      "React Native/Expo, Node.js, Python, Supabase, TensorFlow/MoveNet et publication mobile selon etat du projet.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.SAAS, PROJECT_TAGS.AI],
    stack: ["React Native", "Expo", "Node.js", "Python", "MoveNet", "Supabase"],
    meta: {
      year: 2025,
      duration: "MVP",
      deliveryMode: "Dreamer Agency",
      confidentiality: "Public selon disponibilite",
      availability: "MVP / iterations produit",
    },
    infra: [
      "Application mobile",
      "Backend Node.js",
      "Services Python pour scoring",
      "Supabase pour les donnees",
    ],
    role: [
      "Developpement mobile",
      "Backend API",
      "Integration MoveNet",
      "Scoring et progression",
    ],
    highlights: [
      "Analyse de mouvements via camera",
      "Scoring par exercice",
      "Progression et gamification",
      "Backend de traitement dedie",
    ],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "callgestia",
    title: "Callgestia",
    shortTitle: "Callgestia",
    subtitle:
      "Assistant IA telephone pour automatiser des appels, qualifier des demandes et connecter des outils metier",
    type: "Assistant vocal IA",
    strategicLevel: "strong",
    status: "in-progress",
    section: "apps",
    priority: 10,
    featured: false,
    summary:
      "Projet IA vocal autour des appels, de l'assistance conversationnelle et de l'integration backend.",
    businessSummary:
      "Projet a fort potentiel pour montrer automatisation, IA temps reel et logique metier.",
    technicalSummary:
      "Backend, orchestration d'appels, IA conversationnelle et integrations API.",
    tags: [PROJECT_TAGS.SAAS, PROJECT_TAGS.AI, PROJECT_TAGS.IN_PROGRESS],
    stack: ["Node.js", "API", "IA vocale", "Automatisations"],
    meta: {
      year: 2026,
      duration: "En developpement avance",
      deliveryMode: "Produit Dreamer Agency",
      confidentiality: "Projet en developpement",
      availability: "En developpement",
    },
    infra: ["Backend API", "Orchestration appels", "Integrations metier"],
    role: ["Architecture backend", "Integration IA", "Automatisations", "API"],
    highlights: [
      "Assistant vocal",
      "Qualification de demandes",
      "Automatisations connectees au metier",
    ],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "cashping",
    title: "Cashping",
    shortTitle: "Cashping",
    subtitle:
      "Application de gestion d'argent connectee a une boite mail pour extraire et suivre des informations utiles",
    type: "Application mobile finance personnelle",
    strategicLevel: "strong",
    status: "prototype",
    section: "apps",
    priority: 20,
    featured: false,
    summary:
      "Application mobile de suivi financier leger, connectee a une boite mail pour exploiter des informations de depenses.",
    businessSummary:
      "Projet interessant pour montrer integration OAuth/mail, extraction de donnees et experience mobile.",
    technicalSummary:
      "Flutter, backend Node.js, OAuth/Gmail API et traitement de donnees.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.TOOL],
    stack: ["Flutter", "Node.js", "Gmail API", "OAuth"],
    meta: {
      year: 2026,
      duration: "Prototype",
      deliveryMode: "Projet produit",
      confidentiality: "Prototype",
      availability: "Prototype",
    },
    infra: ["Application Flutter", "Backend Node.js", "Connexion boite mail"],
    role: ["Developpement mobile", "Backend API", "Integration OAuth", "Traitement donnees"],
    highlights: [
      "Connexion boite mail",
      "Suivi d'informations financieres",
      "Notifications possibles",
    ],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "psychia",
    title: "PsychIA",
    shortTitle: "PsychIA",
    subtitle:
      "Application de bien-etre mental avec compagnon IA, chat, vocal, communaute anonyme et exercices guides",
    type: "Application mobile bien-etre",
    strategicLevel: "strong",
    status: "mvp",
    section: "apps",
    priority: 30,
    featured: false,
    summary:
      "Application de bien-etre mental concue autour d'un compagnon IA, d'exercices guides et d'espaces d'entraide.",
    businessSummary:
      "Projet sensible, utile pour montrer mobile, IA et produit communautaire avec une presentation prudente.",
    technicalSummary:
      "React Native, backend, Docker, Python et integration IA personnalisee selon perimetre.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.AI],
    stack: ["React Native", "Docker", "Python", "IA personnalisee"],
    meta: {
      year: 2025,
      duration: "MVP",
      deliveryMode: "Dreamer Agency",
      confidentiality: "Public selon disponibilite",
      availability: "MVP / iterations produit",
    },
    infra: [
      "Application mobile",
      "Backend et orchestration IA",
      "Dockerisation",
      "Stockage local de certains contenus selon perimetre",
    ],
    role: [
      "Developpement mobile",
      "Backend",
      "Integration IA",
      "Architecture produit",
    ],
    highlights: [
      "Compagnon IA bienveillant",
      "Chat et appels vocaux selon perimetre",
      "Communaute d'entraide anonyme",
      "Suivi d'humeur, exercices guides et journal local chiffre",
    ],
    links: { website: "https://psychia.fr/", appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [
      { src: "/media/achievements/psychia_1.png", format: "mobile" },
      { src: "/media/achievements/psychia_2.png", format: "mobile" },
      { src: "/media/achievements/psychia_3.png", format: "mobile" },
      { src: "/media/achievements/psychia_4.png", format: "mobile" },
    ],
    hasDetailedCaseStudy: false,
    isPublic: true,
    sensitiveNote:
      "Application presentee comme un outil de bien-etre et d'ecoute. Elle ne remplace pas un professionnel de sante.",
  },
  {
    slug: "spotigo",
    title: "Spotigo / ParkSpot",
    shortTitle: "Spotigo",
    subtitle:
      "Application mobile de reperage de parkings et places disponibles avec carte et options premium selon perimetre",
    type: "Application mobile carte",
    strategicLevel: "strong",
    status: "prototype",
    section: "apps",
    priority: 40,
    featured: false,
    summary:
      "Application mobile autour de la recherche de stationnement, de la carte et de donnees de disponibilite.",
    businessSummary:
      "Projet utile pour montrer geolocalisation, carte et logique mobile orientee service.",
    technicalSummary:
      "React Native/Expo, Node.js, carte, API et paiement premium si active.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.TOOL],
    stack: ["React Native", "Expo", "Node.js", "Cartographie"],
    meta: {
      year: 2026,
      duration: "Prototype",
      deliveryMode: "Projet produit",
      confidentiality: "Prototype",
      availability: "Prototype",
    },
    infra: ["Application mobile", "Backend API", "Carte et geolocalisation"],
    role: ["Developpement mobile", "Backend API", "Cartographie", "Parcours premium"],
    highlights: ["Carte", "Recherche de parking", "Disponibilite de places", "Options premium possibles"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "study-leveling",
    title: "Study Leveling",
    shortTitle: "Study Leveling",
    subtitle:
      "Application d'etude gamifiee avec progression, XP, donjons et objectifs de concentration",
    type: "Application mobile gamifiee",
    strategicLevel: "strong",
    status: "in-progress",
    section: "apps",
    priority: 50,
    featured: false,
    summary:
      "Application d'apprentissage gamifiee pour transformer les sessions d'etude en progression RPG.",
    businessSummary:
      "Projet interessant pour montrer gamification, mobile et logique de progression.",
    technicalSummary:
      "Flutter, Node.js, progression, XP, objectifs et structure de donjons.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.GAME, PROJECT_TAGS.IN_PROGRESS],
    stack: ["Flutter", "Node.js", "Gamification"],
    meta: {
      year: 2026,
      duration: "En cours",
      deliveryMode: "Projet produit",
      confidentiality: "Projet en cours",
      availability: "En cours",
    },
    infra: ["Application Flutter", "Backend Node.js", "Systeme de progression"],
    role: ["Developpement mobile", "Backend", "Game design", "Architecture produit"],
    highlights: ["XP", "Donjons", "Progression", "Objectifs d'etude"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "shopisan",
    title: "Shopisan",
    shortTitle: "Shopisan",
    subtitle:
      "Application mobile de referencement de boutiques sur carte avec espace de gestion proprietaire",
    type: "Application mobile marketplace locale",
    strategicLevel: "strong",
    status: "prototype",
    section: "apps",
    priority: 60,
    featured: false,
    summary:
      "Application mobile pour decouvrir des boutiques sur carte et permettre aux proprietaires de gerer leur presence.",
    businessSummary:
      "Projet utile pour montrer carte, gestion de comptes et logique multi-profils.",
    technicalSummary:
      "React Native, Firebase, carte, profils boutiques et espace proprietaire.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.TOOL],
    stack: ["React Native", "Firebase", "Carte"],
    meta: {
      year: 2026,
      duration: "Prototype",
      deliveryMode: "Projet produit",
      confidentiality: "Prototype",
      availability: "Prototype",
    },
    infra: ["Application mobile", "Firebase", "Gestion boutiques"],
    role: ["Developpement mobile", "Architecture Firebase", "Carte", "Gestion proprietaire"],
    highlights: ["Carte de boutiques", "Fiches boutiques", "Gestion proprietaire", "Recherche locale"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "go-play",
    title: "Go Play",
    shortTitle: "Go Play",
    subtitle:
      "Application mobile listant des aires de jeux et services utiles aux parents et enfants",
    type: "Application mobile locale",
    strategicLevel: "strong",
    status: "prototype",
    section: "apps",
    priority: 80,
    featured: false,
    summary:
      "Application mobile de decouverte d'aires de jeux et de services associes pour familles.",
    businessSummary:
      "Projet mobile oriente usage local, carte, recherche et donnees terrain.",
    technicalSummary:
      "Flutter, Node.js, carte, fiches de lieux et API backend.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.TOOL],
    stack: ["Flutter", "Node.js", "Cartographie"],
    meta: {
      year: 2026,
      duration: "Prototype",
      deliveryMode: "Projet produit",
      confidentiality: "Prototype",
      availability: "Prototype",
    },
    infra: ["Application Flutter", "Backend Node.js", "Carte et lieux"],
    role: ["Developpement mobile", "Backend API", "Cartographie", "Structure donnees"],
    highlights: ["Aires de jeux", "Recherche de lieux", "Services associes", "Carte"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "snapmeal",
    title: "Snapmeal",
    shortTitle: "Snapmeal",
    subtitle:
      "Application mobile d'idees recettes a partir d'une photo de repas ou d'ingredients, avec suggestion IA",
    type: "Application mobile IA",
    strategicLevel: "strong",
    status: "prototype",
    section: "apps",
    priority: 110,
    featured: false,
    summary:
      "Application mobile autour de la photo alimentaire, de la reconnaissance d'ingredients et de suggestions de recettes.",
    businessSummary:
      "Projet utile pour montrer mobile, IA appliquee et parcours rapide oriente usage quotidien.",
    technicalSummary:
      "Flutter, Node.js, OpenAI/API IA, traitement image et recommandations.",
    tags: [PROJECT_TAGS.MOBILE, PROJECT_TAGS.AI],
    stack: ["Flutter", "Node.js", "OpenAI", "Traitement image"],
    meta: {
      year: 2026,
      duration: "Prototype",
      deliveryMode: "Projet produit",
      confidentiality: "Prototype",
      availability: "Prototype",
    },
    infra: ["Application Flutter", "Backend Node.js", "API IA"],
    role: ["Developpement mobile", "Backend API", "Integration IA", "Parcours produit"],
    highlights: ["Photo de repas", "Ingredients", "Suggestions de recettes", "IA"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "dctp",
    title: "DCTP",
    shortTitle: "DCTP",
    subtitle:
      "Site vitrine 5 pages pour artisan en geothermie, oriente clarte, confiance et demande de contact",
    type: "Site vitrine artisan",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 20,
    featured: false,
    summary:
      "Site vitrine pour presenter une activite artisanale, ses services et faciliter la prise de contact.",
    businessSummary:
      "Projet client utile pour montrer livraison rapide, structure claire et presence professionnelle.",
    technicalSummary:
      "Vite.js, integration responsive, pages service et optimisation de base.",
    tags: [PROJECT_TAGS.WEB],
    stack: ["Vite", "HTML/CSS", "SEO de base"],
    meta: {
      year: 2025,
      duration: "Site vitrine",
      deliveryMode: "Dreamer Agency",
      confidentiality: "Projet client",
      availability: "Projet livre",
    },
    infra: ["Site vitrine", "Pages services", "Formulaire / contact selon perimetre"],
    role: ["Integration", "Structure pages", "Responsive", "Mise en ligne"],
    highlights: ["Site 5 pages", "Presentation metier", "Structure claire", "Contact"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "etiopathe",
    title: "Etiopathe",
    shortTitle: "Etiopathe",
    subtitle: "Site vitrine WordPress 5 pages pour une activite d'etiopathie",
    type: "Site vitrine WordPress",
    strategicLevel: "client",
    status: "client-project",
    section: "clients",
    priority: 50,
    featured: false,
    summary:
      "Site vitrine WordPress simple pour presenter une activite, les informations utiles et les moyens de contact.",
    businessSummary:
      "Projet client a conserver dans la section sites vitrines, sans le mettre au niveau des produits full-stack.",
    technicalSummary:
      "WordPress, structure 5 pages, integration et mise en ligne.",
    tags: [PROJECT_TAGS.WEB],
    stack: ["WordPress"],
    meta: {
      year: "A preciser",
      duration: "Site vitrine",
      deliveryMode: "Projet client",
      confidentiality: "Public",
      availability: "Livre",
    },
    infra: ["WordPress", "Pages de presentation", "Mise en ligne"],
    role: ["Creation site", "Integration WordPress", "Structure pages"],
    highlights: ["Site vitrine", "Presentation activite", "Contact", "Structure claire"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
  {
    slug: "easy-school",
    title: "Easy School",
    shortTitle: "Easy School",
    subtitle: "Ancien projet web conserve comme archive discrete",
    type: "Ancien projet web",
    strategicLevel: "archive",
    status: "prototype",
    section: "archive",
    priority: 10,
    featured: false,
    summary:
      "Ancien projet web conserve comme trace de parcours, sans etre mis en avant dans la selection principale.",
    businessSummary:
      "Projet a garder discret car il est moins aligne avec le positionnement React/Node/TypeScript actuel.",
    technicalSummary: "Projet web plus ancien, details limites.",
    tags: [PROJECT_TAGS.WEB],
    stack: ["Web"],
    meta: {
      year: "A preciser",
      duration: "Archive",
      deliveryMode: "Projet ancien",
      confidentiality: "Archive",
      availability: "Archive",
    },
    infra: [],
    role: ["Projet web ancien"],
    highlights: ["Archive discrete"],
    links: { website: null, appStore: null, playStore: null },
    brand: { logo: null },
    gallery: [],
    hasDetailedCaseStudy: false,
    isPublic: true,
  },
];

const featuredCaseStudies = {
  autogestia: {
    context:
      "Autogestia est pense comme une application de gestion pour artisans et petites entreprises, avec un besoin central : regrouper les actions metier dans une interface claire.",
    problem:
      "Les usages vises melangent devis, factures, suivi administratif, automatisations et aide a la saisie. Le principal enjeu est de garder une experience simple tout en preparant une architecture SaaS evolutive.",
    solution:
      "La V1 structure le produit autour d'une interface de gestion, d'un backend metier, de donnees organisees et de briques d'automatisation. L'assistance IA vocale reste presentee comme une brique produit selon le perimetre reel.",
    role:
      "Conception produit, modelisation des donnees, architecture full-stack, developpement frontend/backend et cadrage des automatisations.",
    keyFeatures: [
      "Gestion de devis et factures",
      "Interface de pilotage metier",
      "Donnees structurees par client, document et action",
      "Automatisations pour reduire les taches repetitives",
      "Briques d'assistance IA vocale selon le perimetre du projet",
    ],
    technicalChoices: [
      "Architecture full-stack orientee SaaS",
      "Separation claire entre interface, logique metier et donnees",
      "API backend pour centraliser les regles de gestion",
      "Structure prevue pour integrations et automatisations futures",
    ],
    challenges: [
      "Transformer des besoins terrain en parcours simples",
      "Eviter une interface trop dense malgre la richesse fonctionnelle",
      "Preparer une base maintenable avant d'etendre le produit",
    ],
    recruiterTakeaways: [
      "Capacite a concevoir une application metier complete",
      "Approche produit, pas seulement execution d'ecrans",
      "Maitrise frontend, backend, donnees et automatisations",
    ],
    clientTakeaways: [
      "Possibilite de construire un outil sur mesure pour un metier specifique",
      "Cadrage progressif d'un SaaS sans sur-complexifier la V1",
      "Attention portee aux usages quotidiens et a la maintenabilite",
    ],
    statusNote:
      "Projet en developpement : l'etude de cas restera volontairement sobre jusqu'a validation des elements publiables.",
  },
  relyo: {
    context:
      "Relyo est une plateforme metier autour de profils professionnels, demandes, missions, reseau et messagerie.",
    problem:
      "Le projet demande de relier plusieurs types d'utilisateurs, des statuts, des interactions et des donnees metier sans perdre la lisibilite du parcours.",
    solution:
      "La structure repose sur une application React/Vite, un backend Node/Express et une modelisation Prisma pour organiser profils, relations, roles, demandes et interactions.",
    role:
      "Architecture full-stack, conception des parcours, developpement frontend, backend, modelisation des donnees et logique de roles.",
    keyFeatures: [
      "Profils professionnels",
      "Demandes, missions ou prestations",
      "Logique de roles et permissions",
      "Interactions reseau",
      "Messagerie et etats metier",
    ],
    technicalChoices: [
      "Frontend React/Vite pour une interface produit reactive",
      "Backend Node/Express pour centraliser la logique metier",
      "Prisma pour structurer les relations et les statuts",
      "Separation des responsabilites entre UI, API et donnees",
    ],
    challenges: [
      "Garder une navigation claire malgre plusieurs roles",
      "Structurer les relations entre profils, missions et demandes",
      "Prevoir des etats coherents sur des parcours utilisateurs longs",
    ],
    recruiterTakeaways: [
      "Capacite a structurer une application metier avec interactions utilisateurs",
      "Compréhension des roles, permissions, statuts et donnees relationnelles",
      "Experience sur React, Node/Express et Prisma",
    ],
    clientTakeaways: [
      "Construction possible d'une plateforme metier sur mesure",
      "Cadrage des workflows avant developpement",
      "Architecture lisible pour faire evoluer le produit",
    ],
    statusNote:
      "Projet en cours : les details publics restent limites aux elements utiles pour comprendre l'architecture.",
  },
  hyroos: {
    context:
      "Hyroos est une application mobile d'exercices avec camera et scoring de mouvements.",
    problem:
      "Le projet combine experience mobile, acquisition camera, analyse de pose, scoring et persistance des resultats. L'enjeu est de rendre un pipeline technique comprehensible dans un usage mobile simple.",
    solution:
      "L'application s'appuie sur une couche mobile React Native/Expo, un backend Node.js, des traitements Python et une persistance Supabase pour relier capture, analyse, score et progression.",
    role:
      "Developpement mobile, integration du pipeline MoveNet, backend API, scoring et structuration des donnees de progression.",
    keyFeatures: [
      "Capture camera pendant les exercices",
      "Analyse de pose avec MoveNet / TensorFlow",
      "Calcul de score par exercice",
      "Progression utilisateur",
      "Persistance des resultats cote backend",
    ],
    technicalChoices: [
      "React Native / Expo pour l'experience mobile",
      "Node.js pour l'API applicative",
      "Python pour les traitements de scoring",
      "Supabase pour les donnees et la persistance",
    ],
    challenges: [
      "Relier capture mobile, analyse et feedback utilisateur",
      "Construire un scoring exploitable sans alourdir l'experience",
      "Organiser un pipeline client vers serveur puis retour score",
    ],
    recruiterTakeaways: [
      "Experience sur un sujet mobile techniquement exigeant",
      "Capacite a relier IA/vision, backend et interface utilisateur",
      "Compréhension des pipelines de donnees applicatifs",
    ],
    clientTakeaways: [
      "Possibilite de construire une app mobile avec traitement technique avance",
      "Capacite a prototyper une fonctionnalite IA utile sans sur-promesse",
      "Architecture adaptee a des iterations produit",
    ],
    statusNote:
      "MVP / iterations produit : les elements restent presentes sans promettre de performance ou de resultats chiffres.",
  },
  "echo-review": {
    context:
      "EchoReview est un SaaS B2B de gestion d'avis clients et de suivi de reputation en ligne.",
    problem:
      "Le besoin est de proposer un parcours simple pour collecter des retours, orienter les utilisateurs vers les bons liens d'avis et donner de la visibilite aux professionnels dans un dashboard.",
    solution:
      "Le produit combine une interface React, un backend Node.js, une base relationnelle, des integrations Google et un dashboard pour suivre les informations utiles.",
    role:
      "Conception produit, parcours utilisateur, developpement React, backend Node.js, base de donnees, integrations et deploiement.",
    keyFeatures: [
      "Dashboard de suivi",
      "Liens et QR codes pour orienter les avis",
      "Connexion / integration Google selon le perimetre",
      "Gestion de donnees clients et etablissements",
      "Pages et metadonnees utiles a la visibilite",
    ],
    technicalChoices: [
      "React pour l'interface SaaS",
      "Node.js pour le backend",
      "Base relationnelle / MySQL pour structurer les donnees",
      "OAuth Google et integrations API",
      "Open Graph / Twitter Cards pour les pages partagees",
    ],
    challenges: [
      "Rendre un parcours B2B simple pour des utilisateurs non techniques",
      "Gerer des integrations externes sans fragiliser le produit",
      "Conserver une base de donnees claire pour les tableaux de bord",
    ],
    recruiterTakeaways: [
      "Experience sur un SaaS B2B complet",
      "Maitrise de parcours utilisateur, dashboard, API et donnees",
      "Capacite a livrer un produit de bout en bout",
    ],
    clientTakeaways: [
      "Creation possible d'un SaaS metier avec dashboard",
      "Integration d'APIs tierces et de donnees business",
      "Attention portee au deploiement et a la presentation publique du produit",
    ],
    statusNote:
      "Projet public presente sans ajouter de metriques non verifiees.",
  },
  trace: {
    context:
      "Trace / Mystery Hike est une application mobile d'exploration geolocalisee avec carte, tuiles a debloquer, progression et couche sociale.",
    problem:
      "Le produit doit suivre des positions, debloquer des zones, gerer des donnees spatiales et garder une experience mobile lisible.",
    solution:
      "L'architecture associe Flutter, Node.js, Mapbox et H3 pour gerer la carte, les tuiles, la progression et les interactions sociales.",
    role:
      "Design produit, developpement mobile Flutter, backend Node.js, logique de tuiles, progression, badges et fonctionnalites sociales.",
    keyFeatures: [
      "Carte et geolocalisation",
      "Deblocage de tuiles / zones",
      "Progression et succes",
      "Profils, amis, feed ou chat selon perimetre",
      "Backend pour synchroniser les donnees",
    ],
    technicalChoices: [
      "Flutter pour l'application mobile",
      "Node.js pour la logique backend",
      "Mapbox pour la cartographie",
      "H3 pour l'indexation spatiale",
      "Separation entre logique de progression et affichage carte",
    ],
    challenges: [
      "Manipuler des donnees spatiales sans complexifier l'UX",
      "Adapter la logique de tuiles aux differents contextes de deplacement",
      "Garder la couche sociale coherente avec le coeur d'exploration",
    ],
    recruiterTakeaways: [
      "Capacite a concevoir un produit mobile geolocalise complexe",
      "Experience avec cartographie, donnees spatiales et backend",
      "Attention portee a la progression utilisateur et a l'architecture produit",
    ],
    clientTakeaways: [
      "Construction possible d'une app mobile avec carte et logique metier avancee",
      "Cadrage technique des sujets geolocalisation et donnees spatiales",
      "Produit pense pour evoluer au-dela du MVP",
    ],
    statusNote:
      "Le slug reste trace pour ne pas casser les URLs ; le libelle Mystery Hike peut evoluer plus tard si le nom public est confirme.",
  },
  "epopee-vf": {
    context:
      "Velofute / Epopee VF est un fantasy game autour du cyclisme, avec equipes, calendrier, scoring et classements.",
    problem:
      "Le projet demande de traduire des regles de jeu et des resultats sportifs en points, classements et parcours utilisateur comprehensibles sur web et mobile.",
    solution:
      "Le produit repose sur une web app React, une application mobile Flutter et un backend Node.js pour centraliser les regles, les donnees et les classements.",
    role:
      "Design produit, developpement web React, application mobile Flutter, backend Node.js, logique de scoring et publication mobile.",
    keyFeatures: [
      "Creation et gestion d'equipes",
      "Calendrier et modifications selon regles de jeu",
      "Scoring a partir de resultats reels",
      "Classements joueurs et cyclistes",
      "Web app et application mobile",
    ],
    technicalChoices: [
      "React pour l'experience web",
      "Flutter pour l'application mobile",
      "Node.js pour partager la logique backend",
      "Base de donnees pour equipes, points et classements",
      "Backend commun pour eviter la duplication des regles",
    ],
    challenges: [
      "Transformer des regles sportives en logique applicative fiable",
      "Garder une coherence entre web, mobile et backend",
      "Structurer les donnees pour les classements et la progression",
    ],
    recruiterTakeaways: [
      "Capacite a gerer un produit complet web + mobile",
      "Experience sur logique de jeu, scoring et donnees sportives",
      "Maitrise d'une architecture partagee React / Flutter / Node.js",
    ],
    clientTakeaways: [
      "Possibilite de construire un produit digital complet avec logique metier forte",
      "Architecture adaptee a plusieurs interfaces",
      "Attention portee aux regles, aux donnees et a l'experience utilisateur",
    ],
    statusNote:
      "Projet presente sans ajouter de resultats chiffres au-dela des informations deja disponibles.",
  },
};

function withStrategy(project) {
  return {
    type: "Projet digital",
    strategicLevel: "strong",
    status: "production",
    section: "apps",
    priority: 100,
    hasDetailedCaseStudy: false,
    isPublic: true,
    ...project,
    ...(projectStrategy[project.slug] || {}),
    ...(featuredCaseStudies[project.slug]
      ? { caseStudy: featuredCaseStudies[project.slug], hasDetailedCaseStudy: true }
      : {}),
  };
}

export const projects = [
  ...coreProjects.map(withStrategy),
  ...additionalProjects.map(withStrategy),
];

export function getProjectBySlug(slug) {
  return projects.find((p) => p.slug === slug);
}
